import React from 'react';
import { Col, Row } from 'react-bootstrap';
import BlueCommonBtn from '../../../components/common/Buttons/BlueCommonBtn';
import GrayCommonBtn from '../../../components/common/Buttons/GrayCommonBtn';
import ContainerBlue from '../../../components/common/Container/ContainerBlue';
import PortalAccessFields from './PortalAccessFields';

const PortalAccessPage = ({ valuesFormik, changeFormikValues, prev, next, stepper }) => {
  const handlePortalChange = (index, changes) =>
    changeFormikValues({
      ...valuesFormik,
      portalUserList: valuesFormik.portalUserList.map((portal, idx) => (idx === index ? { ...portal, ...changes } : portal))
    });

  const btns = (
    <Row className="prev-next-btns-agency justify-content-center">
      <Col sm={12} md={6} lg={6}>
        <GrayCommonBtn tag="com.tempedge.msg.label.back" onClick={prev} data-testid="portal-access-back-btn" />
      </Col>
      <Col sm={12} md={6} lg={6}>
        <BlueCommonBtn tag="com.tempedge.msg.label.next" type="button" onClick={next} data-testid="portal-access-next-btn" />
      </Col>
    </Row>
  );

  return (
    <ContainerBlue title="com.tempedge.msg.title.accountconfiguration" btns={btns} width={1280}>
      {stepper}
      <PortalAccessFields portalUserList={valuesFormik.portalUserList} onPortalChange={handlePortalChange} />
    </ContainerBlue>
  );
};

export default PortalAccessPage;
